import { client } from '@api/client';

import { endOfDayInMilliseconds, startOfDayInMilliseconds } from '@utils/date';

import { IHistoryProfile } from '@interfaces/assets/assetHistory';
import { IItemsResponse } from '@interfaces/common/response';
import { IGetUserLogDTO } from '@interfaces/user/dto/userDTO';
import { INameTitle } from '@awtg-ltd/react-map-component/dist/interfaces';

import { URL } from './urls';

const {
	userActions,
	userActionsFilter,
} = URL;

const DEFAULT_START_DATE_MS = 0;
const DEFAULT_END_DATE_MS = new Date().getTime();

export const getUserLog = ({
	organizationUser,
	createdAtFrom,
	createdAtTo,
	page,
	pageSize,
	sortDirection,
	sortFieldName,
	userAction,
	organizationId,
}: IGetUserLogDTO): Promise<IItemsResponse<IHistoryProfile>> => {
	const createdAt = createdAtFrom || createdAtTo
		? {
			from: createdAtFrom
				? createdAtFrom
				: createdAtTo
					? startOfDayInMilliseconds(DEFAULT_START_DATE_MS)
					: null,
			to: createdAtTo
				? createdAtTo
				: createdAtFrom
					? endOfDayInMilliseconds(DEFAULT_END_DATE_MS)
					: null,
		}
		: null;

	return client.get(`/${userActionsFilter}`, {
		params: {
			'createdAt.from': createdAt?.from,
			'createdAt.to': createdAt?.to,
			userName: organizationUser,
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			type: userAction,
			organizationId,
		},
	});
};

export const getUserActions = (): Promise<INameTitle[]> => {
	return client.get(`/${userActions}`);
};
